var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrameDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 360,
    viewBox: "0 0 56 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 4,
    r: 4,
    transform: "rotate(90 36 4)",
    fill: "#292929"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "rotate(90 4 4)",
    fill: "#292929"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 4,
    transform: "rotate(90 36 36)",
    fill: "#292929"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 36,
    r: 4,
    transform: "rotate(90 4 36)",
    fill: "#292929"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 68,
    r: 4,
    transform: "rotate(90 36 68)",
    fill: "#292929"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 68,
    r: 4,
    transform: "rotate(90 4 68)",
    fill: "#292929"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 100,
    r: 4,
    transform: "rotate(90 36 100)",
    fill: "#292929"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 100,
    r: 4,
    transform: "rotate(90 4 100)",
    fill: "#292929"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 132,
    r: 4,
    transform: "rotate(90 36 132)",
    fill: "#292929"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 132,
    r: 4,
    transform: "rotate(90 4 132)",
    fill: "#292929"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 164,
    r: 4,
    transform: "rotate(90 36 164)",
    fill: "#292929"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 164,
    r: 4,
    transform: "rotate(90 4 164)",
    fill: "#292929"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 196,
    r: 4,
    transform: "rotate(90 36 196)",
    fill: "#292929"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 196,
    r: 4,
    transform: "rotate(90 4 196)",
    fill: "#292929"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 228,
    r: 4,
    transform: "rotate(90 36 228)",
    fill: "#292929"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 228,
    r: 4,
    transform: "rotate(90 4 228)",
    fill: "#292929"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 260,
    r: 4,
    transform: "rotate(90 36 260)",
    fill: "#292929"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 260,
    r: 4,
    transform: "rotate(90 4 260)",
    fill: "#292929"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 292,
    r: 4,
    transform: "rotate(90 36 292)",
    fill: "#292929"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 292,
    r: 4,
    transform: "rotate(90 4 292)",
    fill: "#292929"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 324,
    r: 4,
    transform: "rotate(90 36 324)",
    fill: "#292929"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 324,
    r: 4,
    transform: "rotate(90 4 324)",
    fill: "#292929"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 356,
    r: 4,
    transform: "rotate(90 36 356)",
    fill: "#292929"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 356,
    r: 4,
    transform: "rotate(90 4 356)",
    fill: "#292929"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameDots);
export default __webpack_public_path__ + "static/media/frame-dots.4e8b2d295c824e49cfb264be523c2bc6.svg";
export { ForwardRef as ReactComponent };